import * as Tooltip from '@radix-ui/react-tooltip';

const TERM_DEFINITIONS: Record<string, string> = {
  'TFA': 'Technical Feasibility Assessment — a 5-stage panel process that formally documents the technical uncertainty in your R&D work. Must be locked before activities and AI classification become available.',
  'R&DTI': 'R&D Tax Incentive — the Australian government program under Division 355 of the ITAA 1997 that provides tax offsets for eligible R&D expenditure.',
  'Confidence score': 'How certain the AI is that a time entry is R&D-related, expressed as 0–100%. Entries above 85% are eligible for bulk approval without individual review.',
  'R&D %': 'The proportion of a time entry attributed to eligible R&D work. A 2-hour entry with 75% R&D = 1.5 R&D hours.',
  'Abandoned work': 'Work that was attempted but ultimately didn\'t succeed — strong evidence of genuine technical uncertainty, which is a key eligibility criterion.',
  'Competence record': 'Documentation that an assessor is a "competent professional" under AusIndustry Div 355-25 — required for each activity.',
  'Claim lock': 'Permanently locks a claim for lodgement — runs a validation checklist first. Cannot be undone.',
  'Access token': 'A scoped 90-day read-only token generated for auditors or advisors to review your claim evidence without needing an Edison account.',
};

interface TermTooltipProps {
  term: keyof typeof TERM_DEFINITIONS;
  children?: React.ReactNode;
}

export function TermTooltip({ term, children }: TermTooltipProps) {
  const definition = TERM_DEFINITIONS[term];
  if (!definition) return <>{children ?? term}</>;

  return (
    <Tooltip.Provider delayDuration={300}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span className="inline-flex items-center gap-1 cursor-help">
            {children ?? term}
            <span className="text-indigo-400 text-xs select-none" aria-hidden="true">ⓘ</span>
          </span>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="z-50 max-w-xs rounded-lg bg-gray-900 px-3 py-2 text-xs text-gray-100 shadow-lg"
            sideOffset={5}
          >
            <p className="font-semibold mb-1">{term}</p>
            <p className="leading-relaxed">{definition}</p>
            <Tooltip.Arrow className="fill-gray-900" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
